import { jsxs as f, jsx as t, Fragment as v } from "react/jsx-runtime";
import { d as g, W as $, j as h } from "../../vendor-CPVnY93G.js";
import { forwardRef as B } from "react";
import { stupidInvertClasses as W } from "../../utils/index.js";
import { getButtonStyles as k } from "../BaseButton/index.js";
import { BaseIcon as s } from "../BaseIcon/index.js";
import { isIconName as r } from "../BaseIcon/typeGuards.js";
import { DotProgress as q } from "../DotProgress/index.js";
import { withTooltip as j } from "../Tooltip/withTooltip.js";
import { omitStyleRenderProps as u } from "../../utils/omitStyleRenderProps/index.js";
import '../../assets/index14.css';const N = "_button_kqylx_1", P = "_fullWidth_kqylx_8", w = "_sm_kqylx_14", z = "_md_kqylx_18", n = {
  button: N,
  fullWidth: P,
  sm: w,
  md: z
}, H = j(
  B(
    ({
      isPendingAriaLabel: p = "Loading",
      size: a = "md",
      fullWidth: _ = !1,
      variant: x,
      href: e,
      startIcon: i,
      endIcon: m,
      children: d,
      __inverted: y,
      type: b = "button",
      ...o
    }, l) => {
      const c = g(
        k({
          size: a,
          variant: x ?? (e ? "secondary" : "primary"),
          ...o
        }),
        n.button,
        n[a],
        _ ? n.fullWidth : void 0,
        y ? W() : void 0
      );
      return typeof e == "string" ? /* @__PURE__ */ f(
        $,
        {
          ...u(o),
          href: e,
          className: c,
          "data-component": "Button",
          ref: l,
          children: [
            r(i) && /* @__PURE__ */ t(s, { icon: i, size: "md" }),
            d,
            r(m) && /* @__PURE__ */ t(s, { icon: m, size: "md" })
          ]
        }
      ) : /* @__PURE__ */ t(
        h,
        {
          ...u(o),
          type: b,
          "data-active": o.isActive ? "true" : void 0,
          className: c,
          "data-component": "Button",
          ref: l,
          children: o.isPending ? /* @__PURE__ */ t(q, { "aria-label": p, size: a }) : /* @__PURE__ */ f(v, { children: [
            r(i) && /* @__PURE__ */ t(s, { icon: i, size: "md" }),
            d,
            r(m) && /* @__PURE__ */ t(s, { icon: m, size: "md" })
          ] })
        }
      );
    }
  )
);
export {
  H as Button
};
